import React from 'react';
import Card from '../Card/Card';
import { FMessage } from '../../hoc/IntlComponents';
import BecomeAMaster from '../MasterAccount/BecomeAMaster';
import ConnectMeToMaster from '../MasterAccount/ConnectMeToMaster';

const MasterConfig = ({ tabProps: { master, intl, showAlert } }) => {
  return (
    <div className="master-config-wrapper">
      <Card.Body className="master-config">
        <div className="column add-member">
          <h6>
            <FMessage id="navigation.master.be-master" />
          </h6>
          <BecomeAMaster master={master} />
        </div>
      </Card.Body>
      <Card.Body className="master-config">
        <div className="column connect-to-master">
          <h6>
            <FMessage id="pages.connect-to-master.title" />
          </h6>
          <ConnectMeToMaster master={master} intl={intl} showAlert={showAlert} />
        </div>
      </Card.Body>
    </div>
  );
};

export default MasterConfig;
